// MDMFieldsConfig.utils.ts

/**
 * Represents a client data field.
 */
export interface MDMField {
  field_code: string;
  field_name: string;
  category: string;
  selected: boolean;
  sourceimg?: string;
}

/**
 * Represents the payload structure to be sent while saving selected fields.
 */
export interface UpdateFieldsPayload {
  codes: string[];
  Update: boolean;
  ClientType: string;
}

/**
 * Option type used for client type dropdown.
 */
export interface ClientTypeOption {
  label: string;
  value: "INDIVIDUAL" | "ENTITY";
}

/**
 * Option type used for field category dropdown.
 */
export interface ReferenceDataOption {
  label: string;
  value: string;
}

/**
 * Dropdown values for selecting the client type.
 */
export const CLIENT_TYPES: ClientTypeOption[] = [
  { label: "Individual", value: "INDIVIDUAL" },
  { label: "Entity", value: "ENTITY" },
];

/**
 * Fallback default field ID sets based on client type.
 */
export const DEFAULT_SELECTED_FIELD_CODES: Record<"INDIVIDUAL" | "ENTITY", string[]> = { 
  INDIVIDUAL: ["client_name","parent_client_ref","contact_name","client_phone_office","client_phone_mobile","client_fax","client_email","federal_id_number","social_security_number","spouse_ssn"],
  ENTITY: ["office","primary_service_type","sub_niche","ownership","entity_wealth","entity_search","entity_envision","entity_outsourcing","tow_aa","tow_consulting","tow_tax"]
};


/**
 * Groups an array of fields by the specified field key.
 * @param fields - List of fields to group
 * @returns A dictionary with keys being category names and values being arrays of fields
 */
export const groupByCategory = (
  fields: MDMField[]
): Record<string, MDMField[]> => {
  return fields.reduce((acc, curr) => {
    if (!acc[curr.category]) {
      acc[curr.category] = [];
    }
    acc[curr.category].push(curr);
    return acc;
  }, {} as Record<string, MDMField[]>);
};
